import React, {Fragment} from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import {fetchUserIfNeeded} from '../../../../../actions/app/support/user';
import TableRow from '../../../components/TableRow';
import SupportTitle from '../../../components/title';

const LeagueUsers = ({leagueInfos, users, dispatch}) => {
  const generateUserTableRow = userId => (
    <TableRow
      label={userId}
      value={
        <Link to="/user-support">
          <div
            style={
              users.usersById[userId] && {
                cursor: 'pointer',
                textDecoration: 'underline',
              }
            }
            onClick={() =>
              users.usersById[userId] &&
              dispatch(
                fetchUserIfNeeded({
                  identifier: users.usersById[userId].username,
                }),
              )
            }>
            {(users.usersById[userId] && users.usersById[userId].username) ||
              '-'}
          </div>
        </Link>
      }
      action={
        <div
          style={{
            color: 'rgb(142 142 142)',
            fontWeight: 'normal',
          }}>
          {(users.usersById[userId] && users.usersById[userId].email) || '-'}
        </div>
      }
      optional={
        (users.usersById[userId] && users.usersById[userId].teamName) || '-'
      }
    />
  );
  return (
    <div>
      <SupportTitle title="Players this season" />
      <table className="table table-sm table-responsive table-striped">
        <thead>
          <tr>
            <th>Id</th>
            <th>username</th>
            <th>email</th>
            <th>teamName</th>
          </tr>
        </thead>
        <tbody>
          {leagueInfos.status === 1
            ? Object.keys(users.usersById).map(userId =>
                generateUserTableRow(userId),
              )
            : Object.keys(leagueInfos.divisions).map(divisionNumber => (
                <Fragment>
                  <TableRow
                    label={
                      <div
                        style={{
                          textDecoration: 'underline',
                        }}>{`Division ${divisionNumber}`}</div>
                    }
                  />
                  {leagueInfos.divisions[divisionNumber].usersIds.map(userId =>
                    generateUserTableRow(userId),
                  )}
                </Fragment>
              ))}
        </tbody>
      </table>
    </div>
  );
};

export default connect(
  () => ({}),
  dispatch => ({dispatch}),
)(LeagueUsers);



// WEBPACK FOOTER //
// ./src/pages/Support/League/Widgets/LeagueUsers/index.js